/**
 * Created with setting codegen.
 */
import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Skip hCaptcha verification for sessions that are determined to be trustworthy based on session analysis
 */
export const FE_SKIP_HCAPTCHA_CALLS_FOR_TRUSTWORTHY_SESSIONS_241209 =
  featureToggle({
    name: "FE_SKIP_HCAPTCHA_CALLS_FOR_TRUSTWORTHY_SESSIONS_241209",
    identifier: "RetailerTokenOrLoggedOutInSession",
    defaultValue: false,
    client: "RETAILER",
    productArea: "ANTI_ABUSE",
    notifyAfter: "2025-11-18",
  });
